import { useEffect, useState } from "react";
import api, { inr, fmtDate } from "../../lib/api";

export default function AdminBilling() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/billing").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  const s = data?.summary;

  return (
    <div data-testid="admin-billing-page">
      <h1 className="font-display text-2xl font-bold tracking-tight text-shipany-navy">Billing & Profitability</h1>
      <p className="text-sm text-slate-500">Revenue vs provider cost across the platform.</p>

      <div className="mt-6 grid grid-cols-2 gap-4 lg:grid-cols-6">
        {[
          ["Revenue", s?.revenue, "text-shipany-blue"], ["Provider Cost", s?.provider_cost, "text-slate-700"],
          ["Gross Profit", s?.gross_profit, "text-emerald-600"], ["Margin", s ? s.margin_pct + "%" : "—", "text-emerald-600", true],
          ["GST Collected", s?.gst_collected, "text-slate-700"], ["COD Outstanding", s?.cod_outstanding, "text-amber-600"],
        ].map(([label, val, cls, raw]) => (
          <div key={label} className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={`admin-billing-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">{label}</p>
            <p className={`mono mt-2 text-lg font-bold ${cls}`}>{raw ? val : (typeof val === "number" ? inr(val) : "—")}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 overflow-x-auto rounded-2xl border border-slate-200 bg-white" data-testid="admin-invoices-table">
        <table className="w-full min-w-[720px] text-sm">
          <thead>
            <tr className="bg-shipany-navy text-left text-xs uppercase tracking-wider text-white">
              <th className="px-5 py-3.5">Invoice</th><th className="px-4 py-3.5">Customer</th><th className="px-4 py-3.5">AWB</th><th className="px-4 py-3.5">Amount</th><th className="px-4 py-3.5">GST</th><th className="px-4 py-3.5">Date</th>
            </tr>
          </thead>
          <tbody>
            {(data?.invoices || []).map((inv) => (
              <tr key={inv.invoice_id} className="border-t border-slate-100">
                <td className="mono px-5 py-3 font-semibold text-shipany-blue">{inv.invoice_number}</td>
                <td className="px-4 py-3 text-xs text-slate-500">{inv.customer_email}</td>
                <td className="mono px-4 py-3 text-xs">{inv.awb}</td>
                <td className="mono px-4 py-3 font-semibold">{inr(inv.amount)}</td>
                <td className="mono px-4 py-3 text-slate-500">{inr(inv.gst)}</td>
                <td className="px-4 py-3 text-xs text-slate-500">{fmtDate(inv.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
